import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    amount: {
        font_variant: TextVariantType.FONT_PARAGRAPH_100,
        color: FOUNDATIONS.color_neutral_font_50,
        word_break: 'break-all',
    },
});
//# sourceMappingURL=commonStyles.js.map